module.exports = __webpack_public_path__ + "img/no-data_list.61a98e32.svg";